import React, { useRef, useEffect } from "react";
import clsx from "clsx";
import styles from "./Modal.module.scss";
import { ModalProps } from "./Modal.interface";

export const Modal: React.FC<ModalProps> = (props) => {
  const { children, isShow, onClose } = props;
  const refFirstGame = useRef<HTMLDivElement>(null);

  const onOutsideClick = (e: any) => {
    if (refFirstGame && !refFirstGame.current?.contains(e.target)) {
      onClose();
    }
  };
  useEffect(() => {
    document.addEventListener("click", onOutsideClick);
    return () => document.removeEventListener("click", onOutsideClick);
  }, []);

  return (
    <div className={clsx(styles.overlay, { [styles.overlayHid]: !isShow })} ref={refFirstGame}>
      <div className={styles.modalContainer}>{children}</div>
    </div>
  );
};
